import {
  CargoType,
  CarrierType,
  CarrierVisitDirection,
  CarrierVisitStatus,
} from '@planning/app/api'
import { IOrderItem } from '@planning/rt-stores/order/OrderItem'
import {
  getVisitDashboardGeneralCargoInfoByOrders,
  getVisitDashboardUnitInfoByOrders,
} from '@planning/utils/order-utils'
import { useTranslate } from '@tolgee/react'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { ReactNode } from 'react'
import { VisitDashboardDirectionCard } from './VisitDashboardDirectionCard'

interface Props {
  orders: IOrderItem[]
  cargoType?: CargoType
  visitId?: number
  visitType?: CarrierType
  visitStatus?: CarrierVisitStatus
  cardFooter?: ReactNode
  isMinimalisticView?: boolean
  isTallyPage?: boolean
  onViewClick?: () => void
  onClickExportOrders?: (direction: CarrierVisitDirection) => void
}
export const InboundDashboardCard = observer(
  ({
    orders,
    cargoType,
    visitId,
    visitType,
    visitStatus,
    cardFooter,
    isMinimalisticView,
    isTallyPage,
    onViewClick,
    onClickExportOrders,
  }: Props) => {
    const { t } = useTranslate()

    const { totalDefinition, archetypeGroups } = computed(() => {
      if (cargoType && cargoType === CargoType.GeneralCargo) {
        return {
          totalDefinition: getVisitDashboardGeneralCargoInfoByOrders(orders).totalDefinition,
          archetypeGroups: [],
        }
      } else {
        return getVisitDashboardUnitInfoByOrders(orders)
      }
    }).get()

    return (
      <VisitDashboardDirectionCard
        title={t('discharge', 'Discharge')}
        cargoType={cargoType}
        totalDefinition={totalDefinition}
        direction={CarrierVisitDirection.Inbound}
        visitId={visitId}
        visitType={visitType}
        visitStatus={visitStatus}
        archetypeGroups={archetypeGroups}
        isMinimalisticView={isMinimalisticView}
        isTallyPage={isTallyPage}
        onViewClick={onViewClick}
        onClickExportOrders={
          onClickExportOrders ? () => onClickExportOrders(CarrierVisitDirection.Inbound) : undefined
        }
        cardFooter={cardFooter}
      />
    )
  },
)
